import { useEffect, useState } from 'react'
import { StatusToast } from './StatusToast'

type CopyableTextProps = {
  value: string
  className?: string
}

export const CopyableText = ({ value, className = '' }: CopyableTextProps) => {
  const [toast, setToast] = useState<{
    message: string
    tone: 'error' | 'success'
  } | null>(null)

  useEffect(() => {
    if (!toast) return

    const timeoutId = window.setTimeout(() => setToast(null), 2000)
    return () => window.clearTimeout(timeoutId)
  }, [toast])

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value)
      setToast({ message: 'Данные скопированы', tone: 'success' })
    } catch {
      setToast({ message: 'Не удалось скопировать данные', tone: 'error' })
    }
  }

  return (
    <>
      <button
        type="button"
        className={`flex items-center gap-1 text-right transition-opacity hover:opacity-70`}
        onClick={() => void handleCopy()}
        title="Скопировать"
      >
        <span className={className}>{value}</span>
        <svg
          aria-hidden="true"
          className="h-4 w-4 shrink-0"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      {toast && (
        <StatusToast
          message={toast.message}
          tone={toast.tone}
          onClose={() => setToast(null)}
        />
      )}
    </>
  )
}
